<template>
  <div></div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'

export default {
  name: 'vue-wave-surfer',

  props: {
    src: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      waveSurfer: null,
      isDestroyed: false
    }
  },

  async mounted () {
    this.waveSurfer = WaveSurfer.create({ container: this.$el, ...this.options })

    try {
      await this.waveSurfer.load(this.src)
    } catch (error) {
      // Destroying the player cancels its in-flight recording download.
      if (!this.isDestroyed || error?.name !== 'AbortError') {
        throw error
      }
    }
  },

  beforeDestroy () {
    this.isDestroyed = true
    if (this.waveSurfer) {
      this.waveSurfer.destroy()
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
}
</style>
